import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { PaymentType, TransactionType } from "../types/payment";

const API_URL = `${process.env.REACT_APP_API_URL}/fee-transactions`;

export interface StudentAccountResponseDto {
    studentAccountNumber: string;
}

export interface FeeTransactionDto {
    transactionId: string; // UUID
    studentAccountNo: string; // UUID
    studentAccountsResponseDto?: StudentAccountResponseDto;
    transactionType: TransactionType;
    paymentType: PaymentType;
    amount: number; // BigDecimal
    sessionName: string;
    className: string;
    localDateTime: string; // LocalDateTime
}

const getFeeTransactionsByClassAndSession = async (classId: number, sessionId: number): Promise<FeeTransactionDto[]> => {
    try {
        const response = await axios.get(`${API_URL}/${classId}/${sessionId}`);
        return response.data;
    } catch (error: any) {
        if (error?.response?.status === 404) {
            return [];
        }
        throw error;
    }
};

export const useFeeTransaction = (classId?: number | null, sessionId?: number | null, enabled: boolean = true) => {
    return useQuery<FeeTransactionDto[], Error>({
        queryKey: ["feeTransactions", classId, sessionId],
        queryFn: () => getFeeTransactionsByClassAndSession(classId!, sessionId!),
        enabled: enabled && !!classId && !!sessionId,
        staleTime: 30000,
        retry: false,
        refetchOnWindowFocus: false,
    });
};
